import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createFamilyRelation = (payload) => {
    return vdkEmHappinessPortalApi.post('family-relations/create', payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const updateFamilyRelation = (payload) => {
    return vdkEmHappinessPortalApi.post(`family-relations/update`, payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const deleteFamilyRelation = (id) => {
    return vdkEmHappinessPortalApi.delete(`family-relations/delete/${id}`);
};
const getFamilyRelationById = (id) => {
    return vdkEmHappinessPortalApi.get(`family-relations/${id}`);
};
const getFamilyRelationsByPersonId = (personId) => {
    return vdkEmHappinessPortalApi.get(`family-relations/person/${personId}`);
};
const familyRelationsAPI = {
    createFamilyRelation,
    updateFamilyRelation,
    deleteFamilyRelation,
    getFamilyRelationById,
    getFamilyRelationsByPersonId
};
export default familyRelationsAPI;
